// Use plain text for emptiness checks; keep the original HTML in API payloads.
export const socialFundRichTextContent = (html) => {
  const template = document.createElement("template");
  template.innerHTML = String(html || "").replace(/<br\s*\/?\s*>|<\/p>|<\/li>/gi, "\n");
  return (template.content.textContent || "").replace(/[\u00a0\u200b\ufeff]/g, " ").trim();
};
